// extracted by mini-css-extract-plugin
export var fadeInOut = "_i-3";
export var icon = "_i-4";
export var savedIndicator = "_i-2";
export var savingIndicator = "_i-0";
export var spin = "_i-1";